import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const main = css`
  max-width: 56rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const actions = css`
  margin-top: 2rem;
  width: 100%;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;

  @media (max-width: ${dimensions.phoneLarge}) {
    flex-direction: column;
  }
`;

export const skeletonScope = css`
  width: 100%;
  margin-bottom: 1rem;
`;
